import { putRoundEvent } from '@/utils/api/agency/rondes'
import * as actionTypes from '@/store/modules/service/action-types'
import * as mutationTypes from '@/store/modules/service/mutation-types'
import { SERVICE_POST_ROUND_EVENT } from '@/store/modules/service/rounds/action-types'
import { SERVICE_ROUND_SET_ACTIVE } from '@/store/modules/service/rounds/mutation-types'
import { getLocation } from '@/utils/io/geolocation'

export default {
  [SERVICE_POST_ROUND_EVENT]: async ({ state, commit, dispatch, getters }, { eventKey, ...payload }) => {
    const _event = payload.event || {}
    const req = {
      eventKey,
      serviceRoundExecution: { id: state.rondeActive },
      ...payload,
      event: {
        ..._event,
        location: _event.location || await getLocation()
      }
    }
    const { event } = await putRoundEvent(req)
    const { serviceRoundExecution } = event
    const serviceRound = serviceRoundExecution.serviceRound || {}
    const serviceRoundExecutions = [...getters.serviceRoundExecutions]
    const i = serviceRoundExecutions.findIndex((s) => s.id === serviceRoundExecution.id)
    if (i === -1) {
      serviceRoundExecutions.push(serviceRoundExecution)
    } else {
      serviceRoundExecutions.splice(i, 1, serviceRoundExecution)
    }
    const rounds = [...getters.rondes]
    if (rounds.findIndex((r) => r.id === serviceRound.id) === -1) {
      await dispatch(actionTypes.SERVICE_REFRESH)
    } else {
      const newService = {
        ...getters.serviceActif,
        serviceRoundExecutions
      }
      if (getters.isCircuit) {
        const { services = [] } = state.active
        const newCircuit = {
          ...state.active,
          services: [...services]
        }
        const i = newCircuit.services.findIndex((s) => s.id === newService.id)
        if (i === -1) {
          throw new Error('Impossible de mettre à jour le service')
        } else {
          newCircuit.services.splice(
            i,
            1,
            newService
          )
        }
        commit(mutationTypes.SERVICE_SET_ACTIVE, newCircuit)
      } else {
        commit(mutationTypes.SERVICE_SET_ACTIVE, newService)
      }
      commit(mutationTypes.SERVICE_SET_EVENT, { target: getters.serviceActif, eventData: event })
    }
    if (eventKey === 'start') {
      commit(SERVICE_ROUND_SET_ACTIVE, serviceRoundExecution.id)
    }
    if (eventKey === 'finish') {
      commit(SERVICE_ROUND_SET_ACTIVE, null)
    }
  }
}
